import { Box, ListItem } from '@domain-group/suit-theme'

import ServiceIcon from '@components/Icons/ServiceIcon'

import type { ServiceModel } from '@models/types'

import useNewOrder from '@modals/NewOrderModal/hooks/useNewOrder'

import ProductSearch from './ProductSearch'

interface ServicesProps {
  agencyId: number,
  callbacks: {
    selectProductSearchResult: ReturnType<typeof useNewOrder>['callbacks']['selectProductSearchResult'],
    selectServiceId: (serviceId: number) => void,
  },
  services: ServiceModel[],
}

const Services = (props: ServicesProps) => {
  const {
    agencyId,
    callbacks: {
      selectProductSearchResult,
      selectServiceId,
    },
    services,
  } = props

  return (
    <Box flexDirection="column" marginTop="large">
      <ProductSearch
        agencyId={agencyId}
        callbacks={{
          selectItem: selectProductSearchResult,
        }}
      />

      <Box flexDirection="column" marginTop="large">
        {services.map((service) => {
          const { id, short_name, title } = service

          return (
            <div data-test-id="serviceListItem" key={id}>
              {/*
               // @ts-expect-error TS2339 */}
              <ListItem.Compact
                boxProps={{
                  borderBottom: 0,
                  paddingX: 0,
                }}
                onClick={() => selectServiceId(id)}
                showAngleIcon
              >
                <Box alignItems="center">
                  <Box marginRight="medium" width={16}>
                    {/*
                     // @ts-expect-error TS2322 */}
                    <ServiceIcon height={16} width={16} serviceKey={short_name} />
                  </Box>

                  {title}
                </Box>
                {/*
               // @ts-expect-error TS2339 */}
              </ListItem.Compact>
            </div>
          )
        })}
      </Box>
    </Box>
  )
}

export default Services
